import React from 'react'
import styles from './Form.module.css'
import FormFields from './FormFields'
import { useForm } from './useForm'
import type { FormFieldItem } from './types'

const formFields: FormFieldItem[] = [
    {
        name: 'companyName',
        label: '会社名',
        required: true,
        type: 'text',
        placeholder: '例）株式会社Foodslabo',
        inputClassName: styles.organization,
    },
    {
        name: 'contactName',
        label: '担当者名',
        required: true,
        type: 'text',
        placeholder: '山田太郎',
        inputClassName: styles.name,
    },
    {
        name: 'phoneNumber',
        label: '連絡先電話番号',
        required: true,
        type: 'tel',
        placeholder: '例）03-1234-5678',
        inputClassName: styles.tel,
    },
    {
        name: 'email',
        label: 'メールアドレス',
        required: true,
        type: 'email',
        placeholder: '例）example@example.com',
        inputClassName: styles.email,
    },
    {
        name: 'inquiryContent',
        label: 'お問い合わせ内容',
        required: false,
        type: 'textarea',
        inputClassName: '',
    },
]

export default function Form() {
    const { formData, isSubmitting, handleChange, handleSubmit } = useForm()

    return (
        <section id='form' className={styles.form}>
            <div className={styles.formWidth}>
                <div
                    className={styles.formFirst}
                    style={{
                        backgroundImage: `url('/pages/business/foodstadium/form_image_v1.png')`,
                    }}
                >
                    <h2>お問い合わせ</h2>
                    <p>
                        <span className={styles.formPc}>右</span>
                        <span className={styles.formSp}>下</span>
                        のフォームより必要事項、お問い合わせ内容をご入力ください。
                        <span className={styles.br}>
                            1営業日以内に弊社担当者より採用DXプラットフォームについてご案内させていただきます。導入開始後、最短1営業日で求人掲載が可能となります。
                        </span>
                    </p>
                </div>
                <div className={styles.formSecond}>
                    <form onSubmit={handleSubmit} className={styles.mainForm}>
                        <dl>
                            <FormFields
                                fields={formFields}
                                formData={formData}
                                onChange={handleChange}
                            />
                            <p className={styles.privacy}>
                                プライバシーポリシーに基づいて、本ページにご記入いただいた個人情報につきましては、当社からの回答にて使用させていただきます。個人情報に関するお問い合わせ窓口は
                                <a
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    href='https://cuolega.co.jp/privacy/'
                                >
                                    プライバシーポリシー
                                </a>
                                と
                                <a
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    href='https://cuolega.co.jp/terms/'
                                >
                                    利用規約
                                </a>
                                をお読みくださいませ。
                            </p>
                            <p className={styles.consent}>
                                <label>
                                    <input
                                        className={styles.checkbox}
                                        type='checkbox'
                                        name='consent'
                                        checked={formData.consent}
                                        onChange={handleChange}
                                        required
                                    />
                                    利用規約・プライバシーポリシーに同意する
                                </label>
                            </p>
                            <button
                                type='submit'
                                className={styles.button}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? '送信中...' : '問い合わせる'}
                            </button>
                        </dl>
                    </form>
                </div>
            </div>
        </section>
    )
}
